import QRCode from 'qrcode'

export default async function generateQR(text) {
	try {
		return await QRCode.toDataURL(text, { width: 290 })
	} catch (err) {
		console.error(err)
	}
}
